export const channelFlag = {
  'course-center': 9,
  'course-detail': 10
}



// WEBPACK FOOTER //
// ./src/defines/channelFlag.js